import { render, staticRenderFns } from "./ListCompanySubsidiary.vue?vue&type=template&id=504a91f5&scoped=true"
import script from "./ListCompanySubsidiary.vue?vue&type=script&lang=js"
export * from "./ListCompanySubsidiary.vue?vue&type=script&lang=js"
import style0 from "./ListCompanySubsidiary.vue?vue&type=style&index=0&id=504a91f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504a91f5",
  null
  
)

export default component.exports